import * as yup from 'yup';
import { types } from '../../types';
import { GENERAL } from '../../constants';

const text = GENERAL.PERSONAL_FORM_VALIDATORS_TEXT;

export const validationSchema = yup.object().shape({
    firstName: yup.string().required(text.firstNameRequired).max(30, text.charactersLimit),
    lastName: yup.string().required(text.lastNameRequired).max(30, text.charactersLimit),
    email: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, text.invalidEmail).required(text.invalidEmail),
    phoneNumber: yup.string().matches(/^[\d]{9}$/g, text.invalidPhoneNumber),
    terms: yup.bool().oneOf([true], text.termsRequired),
    emailMarketing: yup.bool().oneOf([true], text.emailMarketingRequired),
    teacherCardSchools: yup.array(),
});

export const defaultValues: types.TTeacher = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    callMarketing: false,
    emailMarketing: false,
    terms: false,
    teacherCardSchools: [],
};
